export const tokenBatchMintStages = [
    {
        name: 'upload',
        title: 'Publishing to IPFS',
        content: 'Content is uploading to IPFS storage',
        doneContent: 'Content has been uploaded to IPFS storage',
    },
    {
        name: 'mint',
        title: 'Sending transaction',
        content: 'Transaction is sending to the blockchain',
        doneContent: 'Transaction has been send to the blockchain'
    },
    {
        name: 'confirm',
        title: 'Confirmation transaction',
        content: 'Transaction have been successfully confirmed',
    },
]